<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="cfops"
        :headers="headers"
        :rotina-id="ID_TELA_DE_CFOP"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarCFOP()"
        @update="(indice) => abrirDialogEditarCFOP(indice)"
        @delete="(indice) => openDialogDeleteCFOP(indice)"
      >
        <template #[`item.auditar`]="{ item }">
          <v-icon v-if="item.auditar" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>
      <DialogDeEdicaoDeCFOP
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :cfop-param="cfopParam"
        :itens="itensParam"
        @confirmado="atualizarCFOP"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteCFOP" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="cfopDelete">
            Tem certeza que deseja excluir a CFOP <b> {{ cfopDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteCFOP = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerCFOP">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CFOPService from '../../../services/cfop/cfop'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeCFOP from '../../../components/cfops/DialogDeEdicaoDeCFOP'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import CFOP from '../../../models/cfop'
import { ID_TELA_DE_CFOP } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeCFOP
  },
  data: () => ({
    name: 'TelaDeCFOP',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Auditar', value: 'auditar' }
    ],
    cfops: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    cfopParam: new CFOP(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteCFOP: false,
    cfopDelete: new CFOP(),
    indiceCFOPDelete: 0,
    ID_TELA_DE_CFOP: ID_TELA_DE_CFOP
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadCFOPs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar CFOPs cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadCFOPs() {
      this.loading = true
      const response = await CFOPService.getAll()
      this.cfops = response
      this.loading = false
    },

    atualizarCFOP(cfop) {
      if (!cfop) return

      const indice = this.cfops.findIndex((cfopExistente) => cfopExistente.id === cfop.id)

      if (indice === -1) {
        this.cfops.push(cfop)
        this.snackbar.snackTextParam = 'CFOP criada com sucesso.'
      } else {
        this.cfops.splice(indice, 1, cfop)
        this.snackbar.snackTextParam = 'CFOP atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true

      this.loadCFOPs()
    },

    openDialogDeleteCFOP(indice) {
      this.cfopDelete = this.cfops[indice]
      if (!this.cfopDelete.id) return

      this.indiceCFOPDelete = indice
      this.dialogDeleteCFOP = true
    },

    async removerCFOP() {
      try {
        await CFOPService.deleteById(this.cfopDelete.id)
        this.snackbar.snackTextParam = 'CFOP removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.cfops.splice(this.indiceCFOPDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível excluir a CFOP.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteCFOP = false
    },

    abrirDialogCriarCFOP() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.cfopParam = new CFOP()
      this.showDialogParam = true
    },

    abrirDialogEditarCFOP(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.cfopParam = { ...this.cfops[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
